import { zCorpLinkState } from "@/types/company/company.common";
import { zCorpLinkRowDto, zLinkAddResultDto, zLinkChangeResultDto, } from "@/types/company/companyLink.dto";
import { zCorpLinkDom, } from "@/types/company/companyLink.domain";
export const CompanyLinkMapper = {
    /**
     * Строка `v_corp_links` / `v_corp_client_links` / `corp_my_employees`; `state` берётся из данных как есть
     * (CCR-009). `corp_my_employees` (кабинет) не отдаёт `company_name`/`client_id`/`created_by_kind` (CCR-038) —
     * `companyName` подставляет вызывающий код (`CorpEmployee.mapper.ts`), `clientId`/`createdByKind` → `null`.
     */
    rowToDomain(raw) {
        const row = zCorpLinkRowDto.parse(raw);
        return zCorpLinkDom.parse({
            linkId: row.link_id,
            companyId: row.company_id,
            companyName: row.company_name ?? "",
            clientId: row.client_id ?? null,
            clientName: row.client_name ?? null,
            phoneE164: row.phone_e164,
            employeeLabel: row.employee_label ?? null,
            validFrom: row.valid_from,
            validTo: row.valid_to ?? null,
            state: row.state,
            isBlocked: row.is_blocked,
            blockedByKind: row.blocked_by_kind ?? null,
            blockedAt: row.blocked_at ?? null,
            blockReason: row.block_reason ?? null,
            endedReason: row.ended_reason ?? null,
            createdAt: row.created_at,
            createdByKind: row.created_by_kind ?? null,
            ordersCount: row.orders_count,
            lastOrderAt: row.last_order_at ?? null,
            canOrder: row.can_order ?? null,
            companyStatus: row.company_status ?? null,
        });
    },
    addResultToDomain(raw) {
        const dto = zLinkAddResultDto.parse(raw);
        return {
            linkId: dto.linkId,
            state: zCorpLinkState.parse(dto.state),
            clientName: dto.clientName ?? null,
            phoneE164: dto.phoneE164,
            validFrom: dto.validFrom,
            validTo: dto.validTo ?? null,
        };
    },
    changeResultToDomain(raw) {
        const dto = zLinkChangeResultDto.parse(raw);
        return {
            linkId: dto.linkId,
            state: zCorpLinkState.parse(dto.state),
            validFrom: dto.validFrom,
            validTo: dto.validTo ?? null,
            openOrders: dto.openOrders.map((order) => ({
                orderId: order.orderId,
                orderNumber: order.orderNumber ?? null,
                scheduledDate: order.scheduledDate ?? null,
            })),
        };
    },
};
